import React, {useEffect} from 'react';
import styled, {css} from 'styled-components';
import {useSelector} from 'react-redux';

import {logPageLoadEvents} from '@ibibo/analytics';
import {paymentsDataSelector} from '@ibibo/hotels-review-reducer';
import HotelsPaymentModule from '@ibibo/hotels-payment-module';

import PriceBlockLoader from '../../Loadingpage/ReviewPageLoaders/PaymentBlockLoader/PaymentBlockLoader';

const Payment: React.FC<{hotelsPaymentLoading: boolean}> = ({hotelsPaymentLoading, searchType}) => {

  useEffect(() => {
    logPageLoadEvents(`funnel:${searchType} hotels:payments`, {});
  }, []);

  const {descBlockSuccess, paymentResponseSuccess} = useSelector(paymentsDataSelector);
  if (descBlockSuccess)
    return (
      <PaymentBlockOuterWrapDiv>
        <PaymentBlockInnerWrapDiv visible={paymentResponseSuccess}>
          {hotelsPaymentLoading && <PriceBlockLoader />}
          {paymentResponseSuccess && (
            <RequestWrapDiv>
              <PaymodeHeaderMainWrapDiv>
                <PricingTxtSpan>PAYMENT MODE</PricingTxtSpan>
              </PaymodeHeaderMainWrapDiv>
            </RequestWrapDiv>
          )}
          <HotelsPaymentModule />
        </PaymentBlockInnerWrapDiv>
      </PaymentBlockOuterWrapDiv>
    );

  return null;
};

export default Payment;

const PaymentBlockOuterWrapDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    width:100%;
    margin-top:${props.theme.spacing.large.l20};
  `
);

const PaymentBlockInnerWrapDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    width:100%;
    background-color: ${props.theme.colors.white.base};
    border-radius: 1rem;
    box-shadow: 0 4px 8px 0 rgba(138, 107, 118, 0.08);
  `
);

const RequestWrapDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: column;
    width:100%;
  `
);

const PaymodeHeaderMainWrapDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    width:100%;
    padding-top:${props.theme.spacing.large.l15};
    padding-bottom:${props.theme.spacing.large.l15};
    padding-right:${props.theme.spacing.large.l20};
    padding-left:${props.theme.spacing.large.l20};
    justify-content:space-between;
    align-items: center;
  `
);

const PricingTxtSpan = styled.span(
  props => `
    color: ${props.theme.colors.black.base};
    font-weight: ${props.theme.font.fontWeight.black};
    font-size:${props.theme.font.large.font18};
  `
);
